import React from 'react'
import StaticCmsPage from '../../components/nemonto/StaticCmsPage'

const AboutUs = () => (
    <StaticCmsPage slug="about" title="About Us" subtitle="Get to know the team and mission behind Nemonto." />
)

export default AboutUs
